import React  from "react";
import ChargeFinal from "./Charge_final"
import ChargeLanding from "./Charge_Landing";

export default function Charge() {
  return (
    <div id="Charge">
      <ChargeLanding/>
      <ChargeFinal/>
    </div>
  );
} 
